import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { scrollSurfacesToTop } from "../../../../design/motion/scrollSurfacesToTop";

/**
 * Scrolls the SessionPageShell `.reg-scroll` container (and window) to top on route entry.
 * @returns {import('react').RefObject<HTMLDivElement>}
 */
export function useScrollRegSurfaceToTop() {
  const surfaceRef = useRef(null);
  const { pathname, key } = useLocation();

  useLayoutEffect(() => {
    scrollSurfacesToTop();
    const scrollEl = surfaceRef.current?.closest(".reg-scroll");
    scrollEl?.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, key]);

  return surfaceRef;
}
